<template>
    <div class="grid__row">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'GridRow',
}
</script>